import withState from 'recompose/withState';
import withHandlers from 'recompose/withHandlers';
import branch from 'recompose/branch';
import renderNothing from 'recompose/renderNothing';
import compose from 'recompose/compose';
import { connect } from 'react-redux';
import lifecycle from 'recompose/lifecycle';
import get from 'lodash/get';
import React from 'react';

import { fetchPaymentCard, resetPaymentCard } from '../main/payment/actions';
import { getCardId } from '../main/payment/selectors';

const CheckCustomerCard = () => (
  <div className="zeta u-font-color-red">Warning: Client doesn&quot;t have payment card set</div>
);

export default compose(
  connect(
    (state, ownProps) => ({
      cardId: getCardId(state),
      customerId: get(ownProps, 'customer.id'),
    }),
    {
      resetPaymentCard,
      fetchPaymentCard,
    },
  ),
  branch(props => !props.customerId, renderNothing),
  withState('isFetching', 'setFetching', false),
  withHandlers({
    fetchPaymentCard: props => () => props.fetchPaymentCard(props.customerId),
  }),
  lifecycle({
    componentWillMount() {
      this.props.setFetching(true);
      this.props.resetPaymentCard();
      this.props.fetchPaymentCard().then(() => this.props.setFetching(false));
    },
  }),
  branch(props => props.isFetching || props.cardId, renderNothing),
)(CheckCustomerCard);
